<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="115px" class="handle-form">
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="处理时间" prop="handleDate">
              <el-date-picker
                style="width: 100%;"
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="form.handleDate"
                type="datetime"
                placeholder="请选择处理时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="处理人" prop="handleUser">
              <el-input clearable v-model="form.handleUser" placeholder="请输入处理人"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="处理内容" prop="handleContent">
              <el-input
                type="textarea"
                clearable
                v-model="form.handleContent"
                placeholder="请输入处理内容"
                maxlength="500"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="text-align: right">
      <el-button type="primary" @click="onConfirm" size="small">
        确认
      </el-button>
      <el-button @click="cancleRecord" size="small"> 取消 </el-button>
    </div>
  </div>
</template>
<script>
import { dealAlarmMonitoring } from '@/api/nursingHome/security.js';
import { mapGetters } from 'vuex';
export default {
  props: {
    nursinghomeId: '',
    ids: '',
  },
  data() {
    return {
      form: {
        handleDate: this.dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
        handleUser: '',
        handleContent: '已处理',
      },
      formRules: {
        handleDate: [{ required: true, message: '请选择处理时间', trigger: 'change' }],
      },
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  created() {},
  mounted() {
    console.log('userInfo--', this.userInfo);
    this.form.handleUser = this.userInfo && this.userInfo.nick_name || '';
  },
  watch: {},
  methods: {
    onConfirm() {
      this.$refs['formRef'].validate((valid) => {
        if (valid) {
          let params = {
            ids: this.ids,
            ...this.form,
          };
          dealAlarmMonitoring(params).then((res) => {
            this.$message.success('操作成功！');
            this.$emit('success');
          });
        }
      });
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
<style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

::v-deep .el-col-8 {
  height: 54px;
}

::v-deep .handle-form .el-input__icon {
  line-height: inherit !important;
}

.title {
  line-height: 50px;
  font-weight: bolder;
  font-size: 18px;
  margin-bottom: 10px;
}

::v-deep .el-form-item__error {
  position: absolute !important;
}
</style>
